import api from "@/services/api.service";
import { ActionTree } from "vuex";
import { LicenseState } from "./types";
import { RootState } from "../types";

export const actions: ActionTree<LicenseState, RootState> = {
	async fetchLicenseDetails({ commit }, tenantGroupId: number) {
		var licenseDetailsDto = await api.getLicenseDetails(tenantGroupId);
		commit("setLicenseDetails", licenseDetailsDto);
	},
	async setLicenseWithFile({ commit }, updateLicense) {
		var setLicenseResponse = await api.setLicenseWithFile(updateLicense.licenseFile, updateLicense.tenantGroupId);
		var licenseDetailsDto = setLicenseResponse.data;
		commit("setLicenseDetails", licenseDetailsDto);
	},
	async fetchLicensedUserPermissions({ commit }) {
		var userLimitDefinitions = await api.getUserLimitDefinitions();
		commit("setUserLimitDefinitions", userLimitDefinitions);
	}
};
